import { LocationDetailsPageLabels , AccessibilityDetails } from '@/types'

export function locationDetailsPageLabelsFactory(page): LocationDetailsPageLabels {
  const doctorDetails = page.doctorDetails
  return {
    accessibilityDetails: page.accessibilityDetails as AccessibilityDetails,
    accessibility: page.accessibilityLabel as string,
    backToResultsLabel: page.backToResultsLabel as string,
    brands: page.brandsLabel as string,
    doctors: page.doctorsLabel as string,
    getDirections: page.getDirectionsLabel as string,
    hours: page.hoursLabel as string,
    products: page.productsLabel as string,
    services: page.servicesLabel as string,
    doctorDetails: doctorDetails,
    offerButtonLabel: page.offerButtonLabel as string,
    offerPopupIndependent: page.offerPopupIndependent as string,
    scheduleCta: page.scheduleCta as string,
    tieredProviderLabel: page.tieredProviderLabel as string,
    hideAcceptNewPatient: page.doctorDetails.hideAcceptNewPatient as boolean,
    visitProviderSite: page.visitProviderSite as string
  }
}
